"use strict";

var _toConsumableArray = require("/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/toConsumableArray.js");
var _regeneratorRuntime = require("/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/regenerator/index.js");
var _slicedToArray = require("/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/slicedToArray.js");
var _asyncToGenerator = require("/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/asyncToGenerator.js");
var _classCallCheck = require("/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/createClass.js");
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bundleProvider = exports.BundleProvider = void 0;
var url_join_1 = __importDefault(require("url-join"));
var loadjs_1 = __importDefault(require("loadjs"));
var cors_import_1 = require("../utils/cors-import");
var interop_require_1 = require("../utils/interop-require");
var CONTEXT_NAME = 'ModuleInjector'; // sync with packages/webpack-legacy-micro-frontend-plugin/src/micro-frontend-plugin.ts:9
var LOADED_MANIFEST_NAME = '__LOADED_MANIFESTS__';
var MANIFEST_CALLBACK_NAME = 'injectManifestCallback';
var MANIFEST_PATH = 'import-manifest.js';
var STORAGE_NAME = '__LOADED_BUNDLES__';
var container = typeof window !== 'undefined' ? window : {};
var BundleProvider = /*#__PURE__*/function () {
  function BundleProvider() {
    var _this = this;
    _classCallCheck(this, BundleProvider);
    this.loadedBundles = container[STORAGE_NAME] || (container[STORAGE_NAME] = {});
    this.loadedManifests = container[LOADED_MANIFEST_NAME] || (container[LOADED_MANIFEST_NAME] = {});
    this.injectManifest = function (name, manifest) {
      _this.loadedManifests[name] = manifest;
    };
    container[MANIFEST_CALLBACK_NAME] = container[MANIFEST_CALLBACK_NAME] || this.injectManifest;
  }
  _createClass(BundleProvider, [{
    key: "getBundle",
    value: function () {
      var _getBundle = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(namePath, bundlePath) {
        var _ref, _ref2, bundleName, exportName, oldManifest, newManifest;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _ref = Array.isArray(namePath) ? namePath : [namePath], _ref2 = _slicedToArray(_ref, 2), bundleName = _ref2[0], exportName = _ref2[1];
              oldManifest = this.loadedManifests[bundleName];
              _context.next = 4;
              return this.loadManifest(bundlePath);
            case 4:
              newManifest = this.loadedManifests[bundleName];
              if (!((oldManifest === null || oldManifest === void 0 ? void 0 : oldManifest.id) !== newManifest.id)) {
                _context.next = 10;
                break;
              }
              delete container["".concat(bundleName).concat(CONTEXT_NAME)];
              loadjs_1.default.reset();
              _context.next = 10;
              return this.loadBundle(bundleName);
            case 10:
              return _context.abrupt("return", interop_require_1.interopRequire(this.loadedBundles[bundleName], exportName));
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getBundle(_x, _x2) {
        return _getBundle.apply(this, arguments);
      }
      return getBundle;
    }()
  }, {
    key: "loadManifest",
    value: function () {
      var _loadManifest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(path) {
        var manifestPath;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              manifestPath = url_join_1.default(path, MANIFEST_PATH);
              return _context2.abrupt("return", cors_import_1.corsImport(manifestPath, true));
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function loadManifest(_x3) {
        return _loadManifest.apply(this, arguments);
      }
      return loadManifest;
    }()
  }, {
    key: "loadBundle",
    value: function () {
      var _loadBundle = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(name) {
        var chunks, mainIndex, main, dependencies;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              chunks = this.loadedManifests[name].chunks;
              mainIndex = chunks.findIndex(function (dep) {
                return dep.includes("/".concat(name, ".")) && dep.endsWith('.js') && !dep.endsWith('.hot-update.js');
              });
              if (mainIndex === -1) {
                mainIndex = chunks.length - 1;
              }
              main = chunks[mainIndex];
              dependencies = [].concat(_toConsumableArray(chunks.slice(0, mainIndex)), _toConsumableArray(chunks.slice(mainIndex + 1)));
              _context3.next = 7;
              return Promise.all(dependencies.map(function (dependency) {
                return cors_import_1.corsImport(dependency);
              }));
            case 7:
              return _context3.abrupt("return", cors_import_1.corsImport(main));
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function loadBundle(_x4) {
        return _loadBundle.apply(this, arguments);
      }
      return loadBundle;
    }()
  }]);
  return BundleProvider;
}();
exports.BundleProvider = BundleProvider;
exports.bundleProvider = new BundleProvider();